/* eslint-disable jira/filename-case */
export const HELP_BUTTON_UI_STORAGE_KEY = 'help_button_ui_state';
